import { FC } from "react";
import ReactJson from "react-json-view";

import { SHOW_JSON_CONFIGS } from "../appConfig";

interface DebugProps {
  data: object;
  collapsed?: boolean;
  name?: string;
}
export const Debug: FC<DebugProps> = ({ data, collapsed, name }) => {
  if (SHOW_JSON_CONFIGS && typeof data === "object") {
    return (
      <ReactJson
        theme={"shapeshifter:inverted"}
        src={data}
        collapsed={collapsed === undefined ? false : collapsed}
        name={name}
        sortKeys={true}
      />
    );
  }
  return null;
};
